module.exports = __webpack_public_path__ + "static/media/enterprise3.4d011130.png";